import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { PartnerService } from '../services/partner.service';
import { FormBuilder } from '@angular/forms';
import { SnackbarService } from '../services/snackbar.service';
import { environment } from 'projects/foreign-admits/src/environments/environment';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { of, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-student-login',
  templateUrl: './student-login.component.html',
  styleUrls: ['./student-login.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class StudentLoginComponent implements OnInit {
  model: any = {};
  otpModel: any = {};
  layout: FormlyFieldConfig[];
  otpFields: FormlyFieldConfig[];

  loading = true;
  enterMobileStep = true;
  enterOtpStep = false;
  processingBtn = false;
  timer = 29;

  puid: string = '';
  partnerLogo: string = '';
  partnerConsent: string = '';
  isReady = false;
  otpMobileNumber: string;

  dataModel: string = "users";
  otpDataModel = 'users/login-with-mobile-otp';

  constructor(
    private http: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private partnerService: PartnerService,
    private formBuilder: FormBuilder,
    private snackbarService: SnackbarService,
    private apiHelperService: ApiHelperService,
  ) { 
  }

  ngOnInit(): void {
    const hasRefreshed = sessionStorage.getItem('hasRefreshed');
    if (!hasRefreshed) {
      sessionStorage.setItem('hasRefreshed', 'true');
      window.location.reload();
      return;
    }

    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    if (puid) {
      this.puid = puid;
    }

    this.clearLocalStorage();
    this.isReady = true;
    this.setLayout();
    this.setOtpFields();

    setTimeout(() => {
      this.loading = false;
    }, 100);
  }

  setLayout() {
    this.layout = [
      {
        fieldGroupClassName: "row align-items-center custom-input",
        fieldGroup: [
          {
            className: "col-12 text-dark",
            key: "mobile",
            type: "mobile-number",
            templateOptions: {
              required: true,
              label: "Enter your phone number to begin.",
              hideRequiredMarker: false,
            },
            validation: {
              messages: {
                required: 'Mobile number is required',
              },
            }
          },
          {

            className: "text-gray list",
            template: `<small class="list">${this.partnerConsent || 'By providing the mobile number, I agree to override the registry on NCPR/NDNC and authorize us to connect me and send relevant notifications via call, Email, SMS and WhatsApp.'}</small>`
          },

          {
            template: `<small class="text-gray">By continuing you agree to our <span class="text-blue-500">Terms Conditions & Privacy Policy</span></small>`
          }
        ]
      }
    ];
  }

  setOtpFields() {
    this.otpFields = [
      {
        key: 'otp',
        type: 'fa-otp',
        className: "rounded rounded-1 text-dark",
        templateOptions: {
          label: 'Enter the 6-digit OTP sent to your phone.',
          placeholder: 'Enter OTP'
        },
      }
    ];
  }

  clearLocalStorage() {
    localStorage.removeItem('token');
    localStorage.removeItem('appliedFilters');
    localStorage.removeItem('initialFilter');
    localStorage.removeItem('loglevel');
    localStorage.removeItem('results');
    localStorage.removeItem('uid');
    localStorage.removeItem('currentFilter');
    localStorage.removeItem('created');
  }

  startTimer() {
    this.timer = 29;
    let interval = setInterval(() => {
      this.timer--;
      if (this.timer === 0) {
        clearInterval(interval);
        this.timer = 29;
      }
    }, 1000);
  }

  showOtp(mobile: string) {
    if (this.otpMobileNumber && this.otpMobileNumber === mobile) {
      return;
    }

    this.otpModel = { mobile };
    this.otpMobileNumber = mobile;
    this.enterMobileStep = false;
    this.enterOtpStep = true;
    this.startTimer();
  }

  async sendOtp(resendOtp?: string) {
    if (resendOtp === 'resendOtp') {
      this.startTimer();
      this.processingBtn = true;
      setTimeout(() => {
        this.processingBtn = false;
      }, 2000);
    }

    try {
      const mobileNumber = resendOtp ? this.otpMobileNumber : this.model.mobile;

      const response = await this.apiHelperService.postDataWithShortlistingUrl('user/login', {
        mobile: mobileNumber,
        currentPuid: this.puid
      });

      if (!resendOtp) {
        this.showOtp(mobileNumber);
      }

      this.snackbarService.show('OTP sent successfully!', 'success');
    } catch (error: any) {
      this.snackbarService.show(error.error?.message || 'Unable to send OTP', 'error');
    }
  }

  async onSubmit(event: any) {
    if (!event?.mobile) {
      this.snackbarService.show('Please enter a valid mobile number', 'error');
      return;
    }

    this.processingBtn = true;
    try {
      this.model.mobile = event.mobile;
      await this.sendOtp();
    } catch (error) {
      this.snackbarService.show('Failed to send OTP', 'error');
    } finally {
      this.processingBtn = false;
    }
  }

  submitOtp() {
    if (!this.otpModel.otp) {
      this.snackbarService.show('Please enter OTP', 'error');
      return;
    }

    this.apiHelperService.postDataWithShortlistingUrl('user/login-with-mobile-otp', {
      mobile: this.otpMobileNumber,
      otp: this.otpModel.otp,
      currentPuid: this.puid
    }).then(
      (response: any) => {
        localStorage.setItem('token', response.id);
        localStorage.setItem('uid', response.userDetails.uid);
        
        this.snackbarService.show('Login successful!', 'success');
        const puid = this.activatedRoute.snapshot.paramMap.get('puid');
        // Convert Promise to Observable and subscribe
        from(this.getStudentApplicantStatus()).subscribe(
          (isApplicant: boolean) => {
            console.info(isApplicant, 216);
            if (isApplicant) {
              if (puid) {
                this.router.navigate(['/student-dashboard/' + puid]);
              } else {
                this.router.navigate(['/student-dashboard']);
              }
            } else {
              if (puid) {
                this.router.navigate(['/personal-details/' + puid]);
              } else {
                this.router.navigate(['/personal-details']);
              }
            }
          }
        );
      }
    ).catch(
      (error) => {
        this.otpModel = { mobile: this.otpMobileNumber };
        this.snackbarService.show(error.error?.message || 'Invalid OTP. Please try again.', 'error');
      }
    );
  }

  private getStudentApplicantStatus() {
    const uid = localStorage.getItem('uid');
    const token = localStorage.getItem('token');

    if (!uid || !token) {
      console.error('Missing UID or token');
      return of(false);
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    return this.apiHelperService.getDataWithShortlistingUrl(`student-choices/student-applicant-status/${uid}`).then(
      (res: any) => {
        if (typeof res === 'boolean') return res;
        if (res?.data?.status !== undefined) return !!res.data.status;
        if (res?.status !== undefined) return !!res.status;
        return false;
      }
    ).catch(err => {
      console.error('Error checking student applicant status:', err);
      return false;
    });
  }

  goToMobileNumber() {
    this.enterOtpStep = false;
    this.enterMobileStep = true;
  }

  goBack() {
    if (this.puid) {
      this.router.navigate(['/' + this.puid]);
    } else {
      this.router.navigate(['/']);
    }
  }

  dataProcessor(data: any) {
    return data;
  }
}